<template>
  <div
    class="dropdown-button"
    :class="{
      'dropdown-button_active': value
    }"
    @click="toggleDropdown"
  >
    <MIcon
      :icon="iconArrow"
      class="dropdown-button__icon"
    />
  </div>
</template>

<script>
  import iconArrow from 'assets/icons/outline-arrow-down.svg';
  import MIcon from 'components/Design/MIcon';

  export default {
    name: 'DropdownButton',
    components: {MIcon},
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        iconArrow
      };
    },
    methods: {
      toggleDropdown () {
        this.$emit('input', !this.value);
      }
    }
  };
</script>

<style>
  .dropdown-button {
    cursor: pointer;

    display: flex;

    justify-content: center;
    align-items: center;

    width: 16px;
    height: 16px;

    border-radius: 2px;
    user-select: none;
  }

  .dropdown-button:hover {
    background: var(--action-border-color);
  }

  .dropdown-button__icon {
    flex-grow: 0;
    flex-shrink: 0;

    width: 14px;
    height: 14px;

    transform: rotate(-90deg);

    transition: 150ms ease-in-out;
  }

  .dropdown-button_active .dropdown-button__icon {
    transform: rotate(0);
  }

</style>
